export type ReturnType<T> = [Error, undefined] | [undefined, T]

export abstract class Domain {
  abstract url(): URL

  host<T extends string>(): ReturnType<T> {
    const url = this.url()
    return [undefined, url.host as T]
  }
}
